/* ============================================================
   SASHA — cigar sommelier chat widget (theme asset)
   Ported from the old nav.js, made config-driven so it can be
   dropped into any store. Reads window.SASHA_CONFIG:
     { backend: '...', shop: '...', avatar: '...', isJp: true|false }
   shop: when set (e.g. 'racc'), the widget talks to the multi-shop
   engine at backend/chat/SHOP. When empty, it talks to the old
   single-shop backend at backend/chat. Both live in theme settings.
   ============================================================ */

(function () {

  var CFG = window.SASHA_CONFIG || {};
  var SASHA_BACKEND = CFG.backend || 'https://audible-silk-backlog.ngrok-free.dev';
  var SASHA_SHOP = CFG.shop || '';
  var SASHA_AVATAR = CFG.avatar || '';

  var SASHA_T = {
    en: {
      title: 'Sasha · Cigar Sommelier',
      greeting: "Hi, I'm Sasha, your cigar sommelier. Ask me anything, or tap a topic below.",
      shipping: 'Shipping',
      contact: 'Contact',
      placeholder: 'Type your question…',
      send: 'Send',
      bubble: 'Questions? Ask Sasha',
      emailPlaceholder: 'your@email.com',
      emailSend: 'Continue',
      offline: "I can't reach my desk right now. Please try the topic buttons below, or email info@racccigars.com.",
      shippingAnswer: "We ship within Japan only, by Japan Post. You can pay by PayPal, bank transfer, or cash on delivery (a ¥750 Japan Post surcharge applies to cash on delivery). You'll need to be registered and age-verified (20+) before checkout. Full details are on our Shipping page.",
      contactAnswer: "You can reach the RACC team anytime at info@racccigars.com. We're always happy to help."
    },
    jp: {
      title: 'サシャ · シガーソムリエ',
      greeting: 'こんにちは、シガーソムリエのサシャです。なんでもお気軽にどうぞ。下のトピックもご利用ください。',
      shipping: '配送について',
      contact: 'お問い合わせ',
      placeholder: 'ご質問をどうぞ…',
      send: '送信',
      bubble: 'ご質問はこちらへ',
      emailPlaceholder: 'your@email.com',
      emailSend: '続ける',
      offline: '只今つながりにくくなっています。下のボタンをお試しいただくか、info@racccigars.com までメールをお願いします。',
      shippingAnswer: '配送は日本国内のみ、日本郵便でお届けします。お支払いはPayPal、銀行振込、代金引換からお選びいただけます（代金引換は日本郵便の手数料￥750が加算されます）。ご購入には会員登録と年齢確認（20歳以上）が必要です。詳しくは配送ページをご覧ください。',
      contactAnswer: 'RACCチームへのお問い合わせは info@racccigars.com までお気軽にどうぞ。'
    }
  };

  // Forget the chat on a manual refresh, after 30 minutes idle, or a new session.
  (function () {
    try {
      var wipe = false;
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'reload') wipe = true;
      var ts = parseInt(sessionStorage.getItem('racc_chat_ts') || '0', 10);
      if (ts && Date.now() - ts > 30 * 60 * 1000) wipe = true;
      if (wipe) ['racc_chat_convo', 'racc_chat_open', 'racc_chat_email', 'racc_chat_sid', 'racc_chat_ts']
        .forEach(function (k) { sessionStorage.removeItem(k); });
    } catch (e) {}
  })();

  var sashaConvo = [];
  try { sashaConvo = JSON.parse(sessionStorage.getItem('racc_chat_convo') || '[]') || []; } catch (e) { sashaConvo = []; }
  var sashaEmail = sessionStorage.getItem('racc_chat_email') || null;
  var sashaPending = null;
  var sashaOpened = false;
  var sashaBubbleTimer = null;
  var sashaSid = sessionStorage.getItem('racc_chat_sid');
  if (!sashaSid) { sashaSid = 's_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem('racc_chat_sid', sashaSid); }

  function sashaLang() {
    if (CFG.isJp === true) return 'jp';
    if (CFG.isJp === false) return 'en';
    try { return sessionStorage.getItem('racc_lang') || 'en'; } catch (e) { return 'en'; }
  }

  function buildSasha() {
    if (document.getElementById('sasha-launch')) return;

    var st = document.createElement('style');
    st.textContent = `
      #sasha-launch{position:fixed;bottom:22px;right:22px;z-index:400;width:58px;height:58px;border-radius:50%;background:#0f0b07;border:1px solid rgba(201,169,110,0.5);cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,border-color .2s;box-shadow:0 6px 24px rgba(0,0,0,0.4);}
      #sasha-launch:hover{transform:scale(1.05);border-color:#c9a96e;}
      #sasha-launch svg{width:26px;height:26px;stroke:#c9a96e;fill:none;}
      #sasha-badge{position:absolute;top:-5px;right:-5px;min-width:19px;height:19px;padding:0 5px;border-radius:10px;background:#c0564a;color:#fff;font-family:'Tenor Sans',sans-serif;font-size:11px;line-height:19px;text-align:center;display:none;box-shadow:0 2px 6px rgba(0,0,0,.4);}
      #sasha-badge.show{display:block;}
      #sasha-panel{position:fixed;bottom:90px;right:22px;z-index:400;width:360px;max-width:calc(100vw - 32px);height:520px;max-height:calc(100vh - 130px);background:#0f0b07;border:0.5px solid rgba(201,169,110,0.25);border-radius:4px;display:none;flex-direction:column;overflow:hidden;box-shadow:0 12px 48px rgba(0,0,0,0.5);}
      #sasha-panel.open{display:flex;}
      .sasha-head{display:flex;align-items:center;gap:10px;padding:16px 18px;border-bottom:0.5px solid rgba(201,169,110,0.12);}
      .sasha-ava{width:34px;height:34px;border-radius:50%;object-fit:contain;background:#1a1208;border:0.5px solid rgba(201,169,110,0.3);}
      .sasha-title{flex:1;font-family:'Cormorant Garamond',serif;font-size:16px;color:#f2ead8;letter-spacing:0.04em;}
      .sasha-x{background:none;border:none;color:rgba(242,234,216,0.4);font-size:20px;cursor:pointer;line-height:1;padding:2px 6px;}
      .sasha-x:hover{color:#c9a96e;}
      .sasha-body{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px;scrollbar-width:thin;scrollbar-color:rgba(201,169,110,0.2) transparent;}
      .sasha-msg{max-width:85%;padding:10px 13px;font-size:13px;line-height:1.5;border-radius:10px;white-space:pre-wrap;word-wrap:break-word;}
      .sasha-msg.bot{align-self:flex-start;background:rgba(201,169,110,0.08);color:rgba(242,234,216,0.9);border:0.5px solid rgba(201,169,110,0.15);border-bottom-left-radius:2px;}
      .sasha-msg.user{align-self:flex-end;background:#c9a96e;color:#0a0805;border-bottom-right-radius:2px;}
      .sasha-typing{align-self:flex-start;display:flex;gap:4px;align-items:center;padding:12px 14px;background:rgba(201,169,110,0.08);border:0.5px solid rgba(201,169,110,0.15);border-radius:10px;border-bottom-left-radius:2px;}
      .sasha-typing span{width:6px;height:6px;border-radius:50%;background:rgba(201,169,110,0.6);animation:sashaBlink 1.2s infinite ease-in-out;}
      .sasha-typing span:nth-child(2){animation-delay:.2s;}
      .sasha-typing span:nth-child(3){animation-delay:.4s;}
      @keyframes sashaBlink{0%,60%,100%{opacity:.25;transform:translateY(0);}30%{opacity:1;transform:translateY(-2px);}}
      .sasha-link{color:#c9a96e;text-decoration:underline;text-underline-offset:2px;cursor:pointer;}
      .sasha-link:hover{color:#dbb97e;}
      .sasha-quick{display:flex;flex-wrap:wrap;gap:8px;padding:0 16px 12px;}
      .sasha-chip{font-family:'Tenor Sans',sans-serif;font-size:10px;letter-spacing:0.08em;color:#c9a96e;background:transparent;border:0.5px solid rgba(201,169,110,0.4);padding:7px 12px;border-radius:20px;cursor:pointer;transition:background .2s;}
      .sasha-chip:hover{background:rgba(201,169,110,0.1);}
      .sasha-foot{display:flex;gap:8px;padding:12px 14px;border-top:0.5px solid rgba(201,169,110,0.12);}
      .sasha-input{flex:1;background:#1a1208;border:0.5px solid rgba(201,169,110,0.2);color:#f2ead8;font-family:'Tenor Sans',sans-serif;font-size:13px;padding:10px 12px;border-radius:4px;outline:none;}
      .sasha-input:focus{border-color:rgba(201,169,110,0.5);}
      .sasha-send{background:#c9a96e;color:#0a0805;border:none;font-family:'Tenor Sans',sans-serif;font-size:10px;letter-spacing:0.14em;text-transform:uppercase;padding:0 16px;border-radius:4px;cursor:pointer;white-space:nowrap;}
      .sasha-send:hover{background:#dbb97e;}
      .sasha-jp .sasha-title,.sasha-jp .sasha-msg,.sasha-jp .sasha-input,.sasha-jp .sasha-chip,.sasha-jp .sasha-send{font-family:'Noto Serif JP',serif;}
      #sasha-bubble{position:fixed;bottom:34px;right:90px;z-index:399;max-width:190px;background:#0f0b07;border:0.5px solid rgba(201,169,110,0.4);color:#f2ead8;font-family:'Tenor Sans',sans-serif;font-size:12px;letter-spacing:0.03em;line-height:1.4;padding:10px 14px;border-radius:6px;box-shadow:0 6px 20px rgba(0,0,0,0.4);cursor:pointer;opacity:0;visibility:hidden;transform:translateY(6px);transition:opacity .4s,transform .4s,visibility .4s;}
      #sasha-bubble.show{opacity:1;visibility:visible;transform:translateY(0);}
      #sasha-bubble::after{content:'';position:absolute;right:-7px;bottom:16px;border-top:7px solid transparent;border-bottom:7px solid transparent;border-left:7px solid #0f0b07;}
      #sasha-bubble.jp{font-family:'Noto Serif JP',serif;}
      @media(max-width:480px){#sasha-panel{right:8px;left:8px;width:auto;bottom:84px;}#sasha-launch{bottom:16px;right:16px;}#sasha-bubble{bottom:84px;right:16px;}#sasha-bubble::after{right:18px;bottom:-7px;border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #0f0b07;border-bottom:none;}}
    `;
    document.head.appendChild(st);

    var launch = document.createElement('button');
    launch.id = 'sasha-launch';
    launch.setAttribute('aria-label', 'Chat with Sasha');
    launch.setAttribute('onclick', 'raccSashaToggle()');
    launch.innerHTML = '<svg viewBox="0 0 24 24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 0 1 4 11.5 8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5z"/></svg><span id="sasha-badge">1</span>';
    document.body.appendChild(launch);

    var panel = document.createElement('div');
    panel.id = 'sasha-panel';
    panel.innerHTML =
      '<div class="sasha-head">' +
        '<img class="sasha-ava" src="' + SASHA_AVATAR + '" alt="Sasha">' +
        '<span class="sasha-title" id="sasha-title"></span>' +
        '<button class="sasha-x" onclick="raccSashaToggle()">✕</button>' +
      '</div>' +
      '<div class="sasha-body" id="sasha-body"></div>' +
      '<div class="sasha-quick" id="sasha-quick"></div>' +
      '<div class="sasha-foot" id="sasha-foot"></div>';
    document.body.appendChild(panel);

    var bubble = document.createElement('div');
    bubble.id = 'sasha-bubble';
    bubble.setAttribute('onclick', 'raccSashaToggle()');
    document.body.appendChild(bubble);

    sashaRestoreInput();
    window.raccSashaSetLang(sashaLang());

    setTimeout(sashaShowBubble, 1800);
    setInterval(sashaShowBubble, 60000);
  }

  function sashaShowBubble() {
    var b = document.getElementById('sasha-bubble');
    var p = document.getElementById('sasha-panel');
    if (!b || !p || p.classList.contains('open') || sashaOpened) return;
    b.classList.add('show');
    clearTimeout(sashaBubbleTimer);
    sashaBubbleTimer = setTimeout(function () { b.classList.remove('show'); }, 5000);
  }

  var sashaUnread = 0;
  function sashaNotify() {
    var p = document.getElementById('sasha-panel');
    var b = document.getElementById('sasha-badge');
    if (!p || !b || p.classList.contains('open')) return;
    sashaUnread++;
    b.textContent = String(sashaUnread);
    b.classList.add('show');
  }
  function sashaClearUnread() {
    sashaUnread = 0;
    var b = document.getElementById('sasha-badge');
    if (b) b.classList.remove('show');
  }

  function sashaRender(text) {
    var s = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    s = s.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function (m, label, url) {
      url = url.replace(/^\/{2,}/, '/');
      var ok = /^(https?:\/\/|\/)/.test(url);
      var href = ok ? url : '#';
      return '<a href="' + href + '" class="sasha-link">' + label + '</a>';
    });
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    return s;
  }

  function sashaAddMsg(role, text) {
    var body = document.getElementById('sasha-body');
    if (!body) return;
    var d = document.createElement('div');
    d.className = 'sasha-msg ' + (role === 'user' ? 'user' : 'bot');
    if (role === 'user') d.textContent = text;
    else d.innerHTML = sashaRender(text);
    body.appendChild(d);
    body.scrollTop = body.scrollHeight;
  }

  function sashaShowTyping() {
    var body = document.getElementById('sasha-body');
    if (!body || document.getElementById('sasha-typing')) return;
    var d = document.createElement('div');
    d.className = 'sasha-typing';
    d.id = 'sasha-typing';
    d.innerHTML = '<span></span><span></span><span></span>';
    body.appendChild(d);
    body.scrollTop = body.scrollHeight;
  }

  function sashaHideTyping() {
    var d = document.getElementById('sasha-typing');
    if (d) d.remove();
  }

  function sashaRestoreInput() {
    var foot = document.getElementById('sasha-foot');
    if (!foot) return;
    var t = SASHA_T[sashaLang()];
    foot.innerHTML =
      '<input class="sasha-input" id="sasha-input" type="text" placeholder="' + t.placeholder + '" onkeydown="if(event.key===\'Enter\')raccSashaSend()">' +
      '<button class="sasha-send" id="sasha-send" onclick="raccSashaSend()">' + t.send + '</button>';
  }

  function sashaSaveConvo() {
    try { sessionStorage.setItem('racc_chat_convo', JSON.stringify(sashaConvo)); sessionStorage.setItem('racc_chat_ts', String(Date.now())); } catch (e) {}
  }

  function sashaRestoreConvo() {
    var body = document.getElementById('sasha-body');
    if (!body) return;
    sashaAddMsg('bot', SASHA_T[sashaLang()].greeting);
    sashaConvo.forEach(function (m) { sashaAddMsg(m.role === 'user' ? 'user' : 'bot', m.content); });
  }

  window.raccSashaToggle = function () {
    var p = document.getElementById('sasha-panel');
    if (!p) return;
    var opening = !p.classList.contains('open');
    p.classList.toggle('open');
    if (opening) {
      sashaOpened = true;
      sashaClearUnread();
      try { sessionStorage.setItem('racc_chat_open', '1'); } catch (e) {}
      var b = document.getElementById('sasha-bubble');
      if (b) b.classList.remove('show');
      var body = document.getElementById('sasha-body');
      if (body && body.childElementCount === 0) sashaRestoreConvo();
      var inp = document.getElementById('sasha-input');
      if (inp) inp.focus();
    } else {
      try { sessionStorage.removeItem('racc_chat_open'); } catch (e) {}
    }
  };

  window.raccSashaQuick = function (topic) {
    var t = SASHA_T[sashaLang()];
    if (topic === 'shipping') { sashaAddMsg('user', t.shipping); sashaAddMsg('bot', t.shippingAnswer); }
    else if (topic === 'contact') { sashaAddMsg('user', t.contact); sashaAddMsg('bot', t.contactAnswer); }
  };

  window.raccSashaSend = async function () {
    var input = document.getElementById('sasha-input');
    if (!input) return;
    var text = (input.value || '').trim();
    if (!text) return;
    var t = SASHA_T[sashaLang()];
    input.value = '';
    sashaAddMsg('user', text);
    sashaConvo.push({ role: 'user', content: text });
    sashaSaveConvo();
    sashaShowTyping();
    try {
      var r = await fetch(SASHA_BACKEND + (SASHA_SHOP ? '/chat/' + SASHA_SHOP : '/chat'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
        body: JSON.stringify({ sessionId: sashaSid, messages: sashaConvo, email: sashaEmail })
      });
      var data = await r.json();
      sashaHideTyping();
      var reply = data.reply || t.offline;
      sashaAddMsg('bot', reply);
      sashaNotify();
      sashaConvo.push({ role: 'assistant', content: reply });
      sashaSaveConvo();
    } catch (e) {
      sashaHideTyping();
      sashaAddMsg('bot', t.offline);
      sashaNotify();
    }
  };

  window.raccSashaEmail = function () {
    var el = document.getElementById('sasha-email');
    if (!el) return;
    var email = (el.value || '').trim();
    if (!email || email.indexOf('@') === -1) return;
    sashaEmail = email;
    sessionStorage.setItem('racc_chat_email', email);
    sashaRestoreInput();
    if (sashaPending) {
      var text = sashaPending; sashaPending = null;
      var inp = document.getElementById('sasha-input');
      if (inp) { inp.value = text; window.raccSashaSend(); }
    }
  };

  window.raccSashaSetLang = function (l) {
    var t = SASHA_T[l] || SASHA_T.en;
    var panel = document.getElementById('sasha-panel');
    if (!panel) return;
    panel.classList.toggle('sasha-jp', l === 'jp');
    var title = document.getElementById('sasha-title'); if (title) title.textContent = t.title;
    var send = document.getElementById('sasha-send'); if (send) send.textContent = t.send;
    var input = document.getElementById('sasha-input'); if (input) input.placeholder = t.placeholder;
    var quick = document.getElementById('sasha-quick');
    if (quick) quick.innerHTML =
      '<button class="sasha-chip" onclick="raccSashaQuick(\'shipping\')">' + t.shipping + '</button>' +
      '<button class="sasha-chip" onclick="raccSashaQuick(\'contact\')">' + t.contact + '</button>';
    var bubble = document.getElementById('sasha-bubble');
    if (bubble) { bubble.textContent = t.bubble; bubble.classList.toggle('jp', l === 'jp'); }
  };

  function sashaMaybeReopen() {
    try { if (sessionStorage.getItem('racc_chat_open') === '1') window.raccSashaToggle(); } catch (e) {}
  }

  function init() { buildSasha(); sashaMaybeReopen(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();